import AccommodationIcon from 'assets/svgs/TripIcons/accomodationIcon.svg?react';
import AccommodationOutlineIcon from 'assets/svgs/TripIcons/accomodationIconOutline.svg?react';
import VehicleRentalIcon from 'assets/svgs/TripIcons/driveIcon.svg?react';
import VehicleRentalOutlineIcon from 'assets/svgs/TripIcons/driveIconOutline.svg?react';
import FlightIcon from 'assets/svgs/TripIcons/flightIcon.svg?react';
import FlightOutlineIcon from 'assets/svgs/TripIcons/flightIconOutline.svg?react';
import GroundTransportationIcon from 'assets/svgs/TripIcons/groundTransportIcon.svg?react';
import GroundTransportationOutlineIcon from 'assets/svgs/TripIcons/groundTransportIconOutline.svg?react';
import OtherChargesIcon from 'assets/svgs/TripIcons/otherChargesIcon.svg?react';
import OtherChargesOutlineIcon from 'assets/svgs/TripIcons/otherChargesIconOutline.svg?react';
import RailIcon from 'assets/svgs/TripIcons/railIcon.svg?react';
import RailOutlineIcon from 'assets/svgs/TripIcons/railIconOutline.svg?react';
import { TransactionLayout } from 'common/types/globalTypes';
import React from 'react';
import { TravelAuthorization_travelAuthorization } from 'travelAuthorization/TravelPlan/view/__generated__/TravelAuthorization';
import {
  TRIP_INITIAL_VALUES,
  STOP_MODAL_INITIAL_VALUES,
} from '../../constants';
import { TripItemFormValues } from '../../types';
import { LookupTravelerSearch_lookupTravelerSearch_nodes } from '../BasicForm/TravelerAutoComplete/__generated__/LookupTravelerSearch';

export const useTravelIcon = () => {
  const getIcon = (layoutType: TransactionLayout | null, size?: number) => {
    switch (layoutType) {
      case 'TRAVEL_BOOKING_GROUND_TRANS':
        return (
          <GroundTransportationIcon style={{ height: size, width: size }} />
        );
      case 'TRAVEL_BOOKING_VEHICLE_RENTAL':
        return <VehicleRentalIcon style={{ height: size, width: size }} />;
      case 'TRAVEL_BOOKING_AIR_TRAVEL':
        return <FlightIcon style={{ height: size, width: size }} />;
      case 'TRAVEL_BOOKING_TRAIN_TRAVEL':
        return <RailIcon style={{ height: size, width: size }} />;
      case 'TRAVEL_BOOKING_HOTEL':
        return <AccommodationIcon style={{ height: size, width: size }} />;
      case 'TRAVEL_BOOKING_INCIDENTAL':
        return <OtherChargesIcon style={{ height: size, width: size }} />;
    }
  };

  const getOutlineIcon = (
    layoutType: TransactionLayout | null,
    size?: number
  ) => {
    switch (layoutType) {
      case 'TRAVEL_BOOKING_HOTEL':
        return (
          <AccommodationOutlineIcon style={{ height: size, width: size }} />
        );
      case 'TRAVEL_BOOKING_VEHICLE_RENTAL':
        return (
          <VehicleRentalOutlineIcon style={{ height: size, width: size }} />
        );
      case 'TRAVEL_BOOKING_AIR_TRAVEL':
        return <FlightOutlineIcon style={{ height: size, width: size }} />;
      case 'TRAVEL_BOOKING_GROUND_TRANS':
        return (
          <GroundTransportationOutlineIcon
            style={{ height: size, width: size }}
          />
        );
      case 'TRAVEL_BOOKING_INCIDENTAL':
        return (
          <OtherChargesOutlineIcon style={{ height: size, width: size }} />
        );
      case 'TRAVEL_BOOKING_TRAIN_TRAVEL':
        return <RailOutlineIcon style={{ height: size, width: size }} />;
    }
  };

  return { getIcon, getOutlineIcon };
};

export const buildArrivalName = (
  rentalName?: string | null,
  rentalAddress1?: string | null,
  rentalCityName?: string | null
) =>
  [rentalName, rentalAddress1, rentalCityName].filter(Boolean).join(' ') ||
  null;

export const getInitialValues = (
  layout: TransactionLayout | null,
  selectedTraveler:
    | LookupTravelerSearch_lookupTravelerSearch_nodes
    | null
    | undefined,
  travelAuthorizationData:
    | Partial<TravelAuthorization_travelAuthorization>
    | null
    | undefined,
  tripItem?: TripItemFormValues[]
) => {
  const { bookingFee } = { ...travelAuthorizationData };

  const airTravelDetails = tripItem?.find(
    (item) => item.layout === 'TRAVEL_BOOKING_AIR_TRAVEL'
  );
  const accommodationDetails = tripItem?.find(
    (item) => item.layout === 'TRAVEL_BOOKING_HOTEL'
  );

  if (layout === 'TRAVEL_BOOKING_GROUND_TRANS') {
    const {
      departureDate,
      departureDepotName,
      arrivalDepotName,
      departureArrivalDate,
      returnDate,
      returnArrivalDate,
      returnArrivalDepotName,
      returnDepotName,
    } = { ...airTravelDetails };

    const { rentalName, rentalAddress1, rentalCityName } = {
      ...accommodationDetails,
    };

    const arrivalName = buildArrivalName(
      rentalName,
      rentalAddress1,
      rentalCityName
    );

    const groundTransportationDefaultValues: TripItemFormValues = {
      ...TRIP_INITIAL_VALUES,
      pickupDropName: departureDepotName || null,
      departureDate: departureDate || null,
      departureArrivalDate: departureArrivalDate || null,
      pickupArrivalName: arrivalDepotName || null,
      returnDate: returnDate || null,
      returnDropName: returnDepotName || null,
      returnArrivalDate: returnArrivalDate || null,
      returnArrivalName: returnArrivalDepotName || null,
      pickupArrivalDropName: arrivalName,
      returnName: arrivalName,
      pickupName: selectedTraveler?._pickupAddress || null,
      returnArrivalDropName: selectedTraveler?._pickupAddress || null,
    };
    return groundTransportationDefaultValues;
  } else if (layout === 'TRAVEL_BOOKING_INCIDENTAL') {
    const newValues = {
      ...TRIP_INITIAL_VALUES,
      bookingFeeRate: bookingFee,
    } as TripItemFormValues;
    return newValues;
  } else if (layout === 'TRAVEL_BOOKING_AIR_TRAVEL') {
    const newValues = {
      ...TRIP_INITIAL_VALUES,
      stopModalItems: [
        {
          ...STOP_MODAL_INITIAL_VALUES,
          // arriveDate: isDepart ? departureDate : returnDate,
          // departDate: isDepart ? departureDate : returnDate,
        },
      ],
      stopModalReturnItems: [
        {
          ...STOP_MODAL_INITIAL_VALUES,
          // arriveDate: isDepart ? departureDate : returnDate,
          // departDate: isDepart ? departureDate : returnDate,
        },
      ],
      bookingFeeRate: bookingFee,
    } as TripItemFormValues;
    return newValues;
  } else {
    return TRIP_INITIAL_VALUES;
  }
};
